import React from "react";
import "./card.css";

const Card = ({ title, description, imageUrl, onClick }) => {
  return (
    <div className="card" onClick={onClick}>
      <img src={imageUrl} alt={title} className="card-image" />
      <div className="card-content">
        <h2 className="card-title">{title}</h2>
        <p className="card-description">{description}</p>
      </div>
    </div>
  );
};

export default Card;
